import {EUserRoleFunction} from 'store/slices/user-slice/user-slice-role-functions';

import {IRoleModelSection} from './form-types';

export enum EROLEMODELSECTIONCODES {
    NEWS = 'app.news',
    USER_SETTINGS = 'app.settings.user.settings'
}

export const RoleModelSections: IRoleModelSection[] = [
    {
        functionName: EUserRoleFunction.CREATE,
        section: EROLEMODELSECTIONCODES.NEWS,
    },
    {
        functionName: EUserRoleFunction.CREATE,
        section: EROLEMODELSECTIONCODES.USER_SETTINGS,
    },
];
